import { appsyncQuery } from './appsync-client.js'

const UPDATE_APPEARANCE = `
  mutation UpdateAppearance($theme: String, $mode: String!) {
    updateAppearance(theme: $theme, mode: $mode) { theme mode }
  }
`

export async function updateAppearance({ theme, mode }) {
  const data = await appsyncQuery(UPDATE_APPEARANCE, { theme, mode })
  return data?.updateAppearance
}
